import { createContext } from 'react';
import { ContextValue } from './types';

const LocationModalFormContext = createContext<ContextValue | null>(null);
export default LocationModalFormContext;

export const LocationModalFormProvider = LocationModalFormContext.Provider;
